import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)


axios.defaults.headers.common['x-api-key'] = process.env.VUE_APP_API_KEY
axios.defaults.headers.common['x-custom-header'] = 'Hr+1cf2cXwL6ZuV5jmseao04OqU/OgmY'

export default new Vuex.Store({
  state: {
    status: '',
    title:{ type: String, default: null },
    url: process.env.VUE_APP_API_URL,
    auth_url_chat: '/',
    event: {
      finished: null,
      broadcasting: null,
      url_to: null,
      survey_enabled: null,
      survey: null,
      demo_mode: null,
      modules: Array()
    },
    url_to: null,
    token: null,
    assistant: {
      name: null,
      email: null,
      id: null,
      key_id: null,
      remaining_attempts: null,
      exam_approved: false,
      answered_survey: false,
      session_id: null,
    },
    event_key_id: process.env.VUE_APP_EVENT_KEY,
    stream_is_iframe: 1,
    site_location: null,
    already_answered: false,
    chat_its_open: false,
    watching_broadcast: false,
    data_rating: [],
    data_poll: [],
    data_word_cloud:[],
    room: null,
    online: true,
    join_links: []
  },
  mutations: {
    set_join_links(state, join_links) {
      state.join_links = join_links
    },
    set_online(state, online) {
      state.online = online
    },
    set_room(state, room) {
      state.room = room
    },
    set_data_poll(state, data_poll) {
      state.data_poll = data_poll
    },
    set_data_rating(state, data_rating) {
      state.data_rating = data_rating
    },
    set_data_word_cloud(state, data_word_cloud) {
      state.data_word_cloud = data_word_cloud
    },
    set_watching_broadcast(state, watching_broadcast) {
      state.watching_broadcast = watching_broadcast
    },
    set_chat_its_open(state, chat_its_open) {
      state.chat_its_open = chat_its_open
    },
    set_already_answered(state, already_answered) {
      state.already_answered = already_answered
    },
    set_site_location(state, site_location) {
      state.site_location = site_location
    },
    set_event(state, event) {
      state.event = event
    },
    set_title(state, title) {
      state.title = title
    },
    set_url_to(state, url_to) {
      state.url_to = url_to
    },
    set_event_key_id(state, event_key_id) {
      state.event_key_id = event_key_id
    },
    set_url(state, url) {
      state.url = url
    },
    set_auth_url_chat(state, auth_url_chat) {
      state.auth_url_chat = auth_url_chat
    },
    set_stream_is_iframe(state, stream_is_iframe) {
      state.stream_is_iframe = stream_is_iframe
    },
    auth_success(state, item) {
      state.status = 'success'
      state.token = item.token
      state.assistant = item.assistant
      if(item.remember_me == true) {
        localStorage.setItem('u', item.assistant.key_id)
      }
    },
    logout(state) {
      localStorage.removeItem('u')
      state.token = null
    },
  },
  actions: {
    post({ commit }, api) {
      return new Promise((resolve, reject) => {
        axios({ url: this.state.url + api.url, data: api.data, method: 'POST', headers: api.headers, params: api.params })
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            if(err && err.response) reject(err.response.data)
            else reject(null)
          })
      })
    },
    get({ commit }, api) {
      return new Promise((resolve, reject) => {
        axios({ url: this.state.url + api.url, params: api.params, method: 'GET' })
          .then(resp => {
            resolve(resp)
          }).catch(err => {
            if(err.response.statusText=='Unauthorized') {
              alert('Su sesión ha Expirado')
              sessionStorage.removeItem('token')
              delete axios.defaults.headers.common['Authorization']
              resolve(err.response)
            }
            reject(err.response.data)
          })
      })
    },
    get_static({ commit }, static_file) {
      return new Promise((resolve, reject) => {
        axios({ url: process.env.VUE_APP_PUBLIC_PATH+'static/' + static_file, method: 'GET' })
          .then(resp => {
            resolve(resp)
          }).catch(err => {
            reject(err.response.data)
          })
      })
    },
    download({ commit }, api) {
      return new Promise((resolve, reject) => {
        axios({ url: this.state.url + api.url, data: api.data, method: api.method, headers: api.headers, responseType: 'blob', params: api.params })
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err.response.data)
          })
      })
    },
    download_by_url({ commit }, param) {
      return new Promise((resolve, reject) => {
        axios({ url: param.url, responseType: 'blob' })
          .then(resp => {
            resolve(resp)
          })
          .catch(err => {
            reject(err.response)
          })
      })
    },
  },
  getters: {
    online: (state) => { return state.online },
    room: (state) => { return state.room },
    data_poll: (state) => { return state.data_poll },
    data_rating: (state) => { return state.data_rating },
    data_word_cloud: (state) => { return state.data_word_cloud },
    watching_broadcast: (state) => { return state.watching_broadcast },
    chat_its_open: (state) => { return state.chat_its_open },
    already_answered: (state) => {
      if(state.assistant.answered_survey || state.already_answered) return true
      else return false
    },
    site_location: (state) => {
      return state.site_location
    },
    urlTo: state => state.event.url_to,
    isLoggedIn: state => !!state.token,
    assistant: state => state.assistant,
    eventKeyId: state => state.event_key_id,
    event: state => state.event,
    streamIsIframe: state => state.stream_is_iframe===1?true:false,
    api_url: state => state.url,
    auth_url_chat: state => state.auth_url_chat,
    isModuleActive: (state) => (short_name:null) => { 
      if(!short_name) return false;
      let module = state.event.modules.find((item) => item.short_name == short_name);
      if(module && module.active === 1) return true;
      return false;
    },
    getModule: (state) => (short_name:null) => { 
      if(!short_name) return null;
      let module = state.event.modules.find((item) => item.short_name == short_name);
      if(module) return module;
      return null;
    },
    join_links: (state) => { return state.join_links }
  },
  modules: {
  }
})